import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  variant?: "grid" | "list" | "compact";
}

const typeStyle: Record<NewsItem["type"], string> = {
  新闻: "bg-primary-100 text-primary-700",
  作品介绍: "bg-secondary-100 text-secondary-900",
  行业动态: "bg-accent-100 text-accent-900",
};

export default function NewsCard({ item, variant = "grid" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col gap-1 border-b border-background-200 pb-3 last:border-0 last:pb-0 cursor-pointer"
      >
        <h4 className="line-clamp-2 text-sm font-medium leading-relaxed text-foreground-900 transition-colors group-hover:text-primary-600">
          {item.title}
        </h4>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span>{item.date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line"></i>
            {item.type}
          </span>
        </div>
      </Link>
    );
  }

  if (variant === "list") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row cursor-pointer"
      >
        <div className="relative h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-44">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} 妖精漫画资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <div className="flex flex-wrap items-center gap-2">
            <span className={`rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap ${typeStyle[item.type]}`}>
              {item.type}
            </span>
            <span className="text-xs text-foreground-400">{item.date}</span>
          </div>
          <h3 className="line-clamp-2 text-base font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative h-40 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} 妖精漫画资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap ${typeStyle[item.type]}`}>
          {item.type}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="line-clamp-2 text-base font-medium leading-relaxed text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
        <div className="mt-auto pt-2 text-xs text-foreground-400">{item.date}</div>
      </div>
    </Link>
  );
}